import React from 'react';
import PropTypes from 'prop-types';
import { SpineListWrapper } from './styled';
import SelectableListItem from '../selectable-list-item';

class SpineList extends React.Component {
    renderSpineItems = (spineNodes) => {
        if (spineNodes.length > 0) {
            return spineNodes.map(item => (
                <div className="spacer" key={`${item.id}_${item.isSelected}`}><SelectableListItem
                    id={item.id}
                    isChecked={item.isSelected}
                    name={`${item.id}: ${item.description}`}
                    onChange={this.props.onChange}
                /></div>
            )
            );
        }

        return null;
    }

    render() {
        const { spineNodes } = this.props;
        return (
            <SpineListWrapper>
                {this.renderSpineItems(spineNodes)}
            </SpineListWrapper>
        );
    }
}

SpineList.propTypes = {
    spineNodes: PropTypes.array,
    onChange: PropTypes.func
};

SpineList.defaultProps = {
    spineNodes: []
};

export default SpineList;



// WEBPACK FOOTER //
// ./app/components/spine-list/index.js